import styled from '@emotion/styled';
import { colors } from '../../constants.js/colors';

export const ModalPaper = {
    borderRadius: 20,
    overflow: 'hidden',
    maxWidth: 720,
};

export const Hero = styled.header`
    background: linear-gradient(135deg, ${colors.primary.dark} 0%, #2d5a1f 45%, ${colors.primary.main} 100%);
    color: ${colors.white};
    padding: 24px 28px 20px;
    position: relative;
`;

export const Badge = styled.span`
    display: inline-block;
    background: ${colors.primary.main};
    color: ${colors.primary.dark};
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 4px 10px;
    border-radius: 999px;
    margin-bottom: 10px;
`;

export const HeroTitle = styled.h2`
    margin: 0 0 8px;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.25;
    color: ${colors.white};
`;

export const HeroSubtitle = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 1.45;
    color: rgba(255, 255, 255, 0.92);
    max-width: 520px;
`;

export const CloseButtonWrap = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
`;

export const Body = styled.div`
    padding: 20px 24px 24px;
    background: ${colors.lightWhite};
`;

/** Altura fija compartida entre paso 1 (video + lista) y paso 2 (precios mayoristas). */
export const ContentSlot = styled.div`
    min-height: 472px;
    display: flex;
    flex-direction: column;

    @media (max-width: 600px) {
        min-height: 400px;
    }
`;

export const VideoFrame = styled.div`
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(23, 51, 0, 0.12);
    border: 2px solid ${colors.primary.main};
    background: #000;
    flex-shrink: 0;

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
`;

export const HintList = styled.ul`
    margin: 16px 0 0;
    padding: 0 0 0 18px;
    color: ${colors.text.primary};
    font-size: 14px;
    line-height: 1.5;
    flex-shrink: 0;

    li {
        margin-bottom: 6px;
    }

    li:last-child {
        margin-bottom: 0;
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 20px;
    justify-content: ${({ $spread }) => ($spread ? 'space-between' : 'flex-end')};
    align-items: center;

    @media (max-width: 600px) {
        ${({ $spread }) =>
            $spread &&
            `
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 12px;
            justify-content: stretch;
            align-items: stretch;
        `}
    }
`;

export const ActionsGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: flex-end;

    @media (max-width: 600px) {
        display: contents;
    }
`;

/** Paso 2 mobile: Anterior (col 1) */
export const ActionPrev = styled.div`
    @media (max-width: 600px) {
        grid-column: 1;
        grid-row: 1;

        button {
            width: 100%;
        }
    }
`;

/** Paso 2 mobile: Entendido (col 2) */
export const ActionPrimary = styled.div`
    @media (max-width: 600px) {
        grid-column: 2;
        grid-row: 1;

        button {
            width: 100%;
        }
    }
`;

/** Paso 2 mobile: Ir a… (fila completa abajo, como subcategorías) */
export const ActionLink = styled.div`
    @media (max-width: 600px) {
        grid-column: 1 / -1;
        grid-row: 2;

        button {
            width: 100%;
        }
    }
`;

export const BenefitCardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    width: 100%;
    align-content: start;

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`;

export const BenefitCard = styled.div`
    background: ${colors.white};
    border: 1px solid ${colors.gray.main};
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 2px 10px rgba(23, 51, 0, 0.06);
    display: flex;
    gap: 12px;
    align-items: flex-start;
    min-height: 96px;
`;

export const BenefitIconWrap = styled.div`
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(158, 232, 112, 0.35);
    border: 1px solid ${colors.primary.main};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.primary.dark};

    svg {
        font-size: 22px;
    }
`;

export const BenefitText = styled.div`
    min-width: 0;
`;

export const BenefitTitle = styled.h3`
    margin: 0 0 4px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.3;
    color: ${colors.text.primary};
`;

export const BenefitDescription = styled.p`
    margin: 0;
    font-size: 13px;
    line-height: 1.45;
    color: ${colors.gray.alternative};
`;

/** Callout en el espacio inferior del paso 2 (solo desktop). */
export const ExclusiveCallout = styled.div`
    display: none;

    @media (min-width: 601px) {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: auto;
        padding: 16px 20px;
        border-radius: 14px;
        background: linear-gradient(
            135deg,
            rgba(158, 232, 112, 0.28) 0%,
            rgba(249, 215, 131, 0.35) 100%
        );
        border: 2px dashed ${colors.primary.main};
        box-shadow: 0 4px 16px rgba(23, 51, 0, 0.08);
        text-align: center;
    }
`;

export const ExclusiveCalloutBadge = styled.span`
    display: inline-block;
    background: ${colors.primary.main};
    color: ${colors.primary.dark};
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 4px 10px;
    border-radius: 999px;
`;

export const ExclusiveCalloutText = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${colors.primary.dark};
    line-height: 1.35;
`;

export const StepIndicator = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 16px;
    font-size: 12px;
    font-weight: 600;
    color: ${colors.gray.alternative};
`;

export const StepDot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ active }) => (active ? colors.primary.dark : colors.gray.light)};
`;
